import { Pipe, type PipeTransform } from '@angular/core';
import type { FileUploadResponse } from '../service/file-upload-response';
import { getFileUploadResponseId } from '../function/get-file-upload-response-id';

@Pipe({
  name: 'getFileUploadResponseId',
})
export class GetFileUploadResponseId implements PipeTransform {
  transform(response: FileUploadResponse<string>, index: number): string {
    return getFileUploadResponseId(response, index);
  }
}
